import styled, { css } from 'styled-components';
import { Modal } from 'antd';

// Import styles utilities
import { antModal, media } from 'components/styles';

// Import components
import { Paragraph, Button } from 'components/elements';

export const ModalStyled = styled(Modal)`
	${antModal()}
`;

export const Text = styled(Paragraph.Ellipsis)`
	color: ${({ theme }) => theme.vod.font.white};
	font-weight: ${({ theme }) => theme.font.normal};
	font-size: 1.6rem !important;
	white-space: initial;
	margin-bottom: 1rem;

	${media.min.xmin(css`
		font-size: 2.2rem !important;
	`)}

	${({ description }) =>
		description &&
		css`
			font-weight: ${({ theme }) => theme.font.light};
		`}
`;

export const TextStyled = styled(Paragraph.Ellipsis)`
	font-size: 1.6rem;
	font-weight: ${({ theme }) => theme.font.semiBold};
	color: ${({ theme }) => theme.watchingGEOLock.color};
	text-align: center;
	white-space: normal;
	padding: 0 1.5rem;

	& br {
		display: block;
		margin: 3rem 0;
		content: '';
	}
`;

export const Title = styled(Text)``;
export const Description = styled(Text)``;

export const Content = styled.div`
	text-align: center;
`;

export const ButtonLogIn = styled(Button)`
	margin-top: 2rem;
`;

export const ModalContentWrapper = styled.div`
  margin: 0 auto;
  max-width: 46rem;

  & ${ButtonLogIn} {
    width: 100%;
    font-size: 1.6rem;
    font-weight: ${({ theme }) => theme.font.bold};
    padding: 2rem 1.2rem;
  }
}

${Title} {
  font-weight: ${({ theme }) => theme.font.medium};
  font-size: 2.4rem !important;
}
`;

export const ModalContentVerificationWrapper = styled(ModalContentWrapper)`
	max-width: 100%;
	${Description} {
		color: ${({ theme }) => theme.watchingGEOLock.color};
		font-weight: ${({ theme }) => theme.font.semiBold};
		line-height: 2.4rem;
	}
`;
